import type { Meta, StoryFn } from '@storybook/react';

import { useToaster } from '@pega/cosmos-react-core';
import { AppAnnouncement } from '@pega/cosmos-react-work';
import type { AppAnnouncementProps } from '@pega/cosmos-react-work';

export default {
  title: 'Work/AppAnnouncement',
  component: AppAnnouncement
} as Meta;

export const AppAnnouncementDemo: StoryFn<AppAnnouncementProps> = (args: AppAnnouncementProps) => {
  const { push } = useToaster();

  const details = [
    'New React based UI rendering',
    'Streamlined components for all business needs',
    'Other improvements'
  ];

  return (
    <AppAnnouncement
      heading={args.heading}
      description={args.description}
      details={details}
      whatsNewLink={args.whatsNewLink}
      whatsNewText={args.whatsNewText}
      image={args.image}
      onDismiss={() => push({ content: 'Dismissed AppAnnouncement' })}
    />
  );
};

AppAnnouncementDemo.args = {
  heading: 'Pega Constellation Design System',
  description: 'We have launched a brand new experience to accelerate your workflow!',
  whatsNewLink: 'https://www.pega.com',
  whatsNewText: "See what's new",
  image:
    'https://www.pega.com/sites/default/files/styles/2560/public/media/images/2019-01/pega-logo_0.png'
};

AppAnnouncementDemo.argTypes = {
  heading: { control: { type: 'text' } },
  description: { control: { type: 'text' } },
  whatsNewLink: { control: { type: 'text' } },
  whatsNewText: { control: { type: 'text' } },
  image: { control: { type: 'text' } }
};
